import { render, staticRenderFns } from "./EnergyInfo.vue?vue&type=template&id=2e68fc06"
import script from "./EnergyInfo.vue?vue&type=script&lang=ts"
export * from "./EnergyInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports